import React from "react";
import classes from "./attachModal.module.css";
import icons from "../../../../../Data/icons";
const TimeLineModal = ({ data, closeModal }) => {
  const CloseIcon = icons.close;
  const AttachIcon = icons.attach;
  const TimeLineIcon = icons.timeline;
  const timeline = data?.data.timeline || [];

  return (
    <div className={classes.modalOverLay}>
      <div className={classes.modalCard}>
        <div className={classes.modalHeader}>
          <button className={classes.modalCloseBtn} onClick={closeModal}>
            <CloseIcon />
          </button>
          <h2 className={classes.modalTitle}>تفاصيل الجدول الزمني</h2>
        </div>
        {!data ? (
          <div>no data available</div>
        ) : (
          timeline.map((item) => (
            <div className={classes.modalBody} key={item.id}>
              <div class="user-profile">
                <div class="post-about card-body">
                  <ul class="list-group">
                    <li class="list-group-item">
                      <div class="icon">
                        <TimeLineIcon />
                      </div>
                      <div>
                        <h5 className="mb-1">{item.status}</h5>
                        <p>{item.employe}- {item.date}</p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default TimeLineModal;
